import { StringParam, useQueryParam } from "use-query-params";

export function useGroupQueryParam() {
  const [group, setGroup] = useQueryParam("attributeGroup", StringParam);

  return {
    group,
    setGroup,
  };
}
